"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventMap = void 0;
var EventMap;
(function (EventMap) {
    EventMap["CONNECT"] = "connect";
    EventMap["DISCONNECT"] = "disconnect";
    EventMap["AFTER_LOGIN"] = "SOCKET/AFTER_LOGIN";
    EventMap["JOIN_ROOM"] = "SOCKET/JOIN_ROOM";
    EventMap["CHAT_FROM_CLIENT"] = "SOCKET/CHAT_FROM_CLIENT";
    EventMap["CHAT_FROM_SERVER"] = "SOCKET/CHAT_FROM_SERVER";
})(EventMap = exports.EventMap || (exports.EventMap = {}));
